import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import Pagination from './../shared/pagination'
import VueElementLoading from 'vue-element-loading';
export default {
	name: 'WarehouseMaster',
	components: {
		Paginate,
		Pagination,
		VueElementLoading
	},
	data: function () {
		return {
			totalPage: 0,
			pageLimit: 10,
			totalRows: 0,
			currentPage: 1,
			// totalRows:0,
			gstcheck: 0,
			swarehouseid: '',
			swarehousestatus: '',
			warehousestate: '',
			// currentPage: 0,
			//modalShow used for close the active/inactive modal(default)
			modalShow: false,
			editwarehousemodal: false,
			addwarehousemodal: false,
			addmodalshow: false,
			status: '',
			warehouseaction: '',
			listWarehouseData: [],
			listStateData: [],
			listCityData: [],
			// pageno: 0,
			// totalPage: 0,
			warehousename: '',
			warehouseemail: '',
			contactno: '',
			stateErr: '',
			city_name: '',
			terms: false,
			id: '',
			isLoading: false,
			resultCount: '',

			// initialize form field
			addwarehouse: {
				warehouseid: '',
				warehousename: '',
				warehouseaddress: '',
				warehousecity: '',
				warehousestate: '',
				warehousecountry: '',
				warehousepincode: '',
				contactno: '',
				contactpersonname: '',
				warehouseemail: '',
				stateErr: '',
				totalsqft: '',
				gstno: '',
				status: ''
			},
			status: '',
		}
	},
	created: function () { },
	// when a page loads,mounted() will be call
	mounted() {
		this.pageno = 0
		this.getWarehouselist()
		this.getStateList()
	},
	methods: {
		validateGst() {
			var txtgst = document.getElementById("gstno");
			var regexx = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
			if (regexx.test(txtgst.value.toUpperCase())) {
				this.gstcheck = 0;
			} else {
				this.gstcheck = 1;
				return false;
			}
		},
		validateformat() {
			var txtgst = document.getElementById("gstno");
			var regexx = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/;
			if (regexx.test(txtgst.value.toUpperCase())) {
				this.gstcheck = 0;
				this.stateErr = "";
				if (this.addwarehouse.warehousestate == '') {
					this.stateErr = "The warehouseState field is required"
				}
				if (this.warehouseaction == 'add') {
					this.saveWarehouse()
				} else if (this.warehouseaction == 'edit') {
					this.editWarehouse()
				}
			} else {
				this.gstcheck = 1;
				console.log("Invalid GST NO ");
				return false;
			}
		},
		//open new form(popup)
		addNewWarehouse() {
			this.gstcheck = 0,
				this.addwarehouse = [],
				//to initialize all form field or used for clear the form
				this.warehouseaction = 'add',
				this.addwarehousemodal = true
			//to clear error messages(validation messages)
			this.$validator.reset();
			this.errors.clear();
			this.clearNewForm();
		},
		addmodalShow() {
			this.Statusaction = 'add'
			this.addmodalShow = true
		},
		//to close active/inactive modal
		closeaddmodalShow() {
			this.addmodalShow = false
		},
		//to close new form
		closeAddWarehouseModal() {
			this.addwarehousemodal = false
		},

		clearNewForm() {
			this.addwarehouse.warehouseid = '',
				this.addwarehouse.warehousename = '',
				this.addwarehouse.warehouseaddress = '',
				this.addwarehouse.warehousecity = '',
				this.addwarehouse.warehousestate = '',
				this.addwarehouse.warehousecountry = '',
				this.addwarehouse.warehousepincode = '',
				this.addwarehouse.contactno = '',
				this.addwarehouse.contactpersonname = '',
				this.addwarehouse.warehouseemail = '',
				this.addwarehouse.totalsqft = '',
				this.addwarehouse.gstno = ''
			this.$validator.reset();
			this.errors.clear();
		},

		//to get state list
		getStateList() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'stateList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listStateData = result.data
				}, error => {
					console.error(error)
				})
		},

		//depending on state ,get city list
		getCityList() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				"statename": this.addwarehouse.warehousestate
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cityList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listCityData = result.data

				}, error => {
					console.error(error)
				})
		},

		// save form fields
		saveWarehouse() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'warehouseid': this.addwarehouse.warehouseid,
				'warehousename': this.addwarehouse.warehousename,
				'warehouseaddress': this.addwarehouse.warehouseaddress,
				'warehousecity': this.addwarehouse.warehousecity,
				'warehousestate': this.addwarehouse.warehousestate,
				'warehousecountry': this.addwarehouse.warehousecountry,
				'warehousepincode': this.addwarehouse.warehousepincode,
				'contactno': this.addwarehouse.contactno,
				'contactpersonname': this.addwarehouse.contactpersonname,
				'warehouseemail': this.addwarehouse.warehouseemail,
				'totalsqft': this.addwarehouse.totalsqft,
				'gstno': this.addwarehouse.gstno
			});

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'savewarehouse',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then((response) => {
					if (response.data.errorcode == 1) {
						this.$alertify.success("Warehouse Created Successfully")
						this.clearNewForm();
						this.addwarehousemodal = false
						this.getWarehouselist();
					} else {
						(response.data.errorcode == -1)
						this.$alertify.error("Warehouse already existed")
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		//to get Warehouse list
		getWarehouselist() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				warehousename: this.warehousename.trim(),
				warehouseemail: this.warehouseemail.trim(),
				contactno: this.contactno.trim(),

			})
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehouseListDetails',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listWarehouseData = result.data.data.rows
					this.isLoading = false;
					this.totalRows = result.data.data.count
					this.resultCount = result.data.data.count
					if (this.totalRows < 10) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalRows / 10)
					}
				}, error => {
					console.error(error)
					this.isLoading = false;
				})
		},
		syncWarehouselist() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.isLoading = true;
			axios({
				method: 'GET',
				'url': apiUrl.api_url + 'syncFCWarehouse',
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.$alertify.success(result.data.msg)

					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				})
		},

		//update form fields
		editWarehouse() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				id: this.id,
				warehouseid: this.addwarehouse.warehouseid,
				warehousename: this.addwarehouse.warehousename,
				warehouseaddress: this.addwarehouse.warehouseaddress,
				warehousecity: this.addwarehouse.warehousecity,
				warehousestate: this.addwarehouse.warehousestate,
				warehousecountry: this.addwarehouse.warehousecountry,
				warehousepincode: this.addwarehouse.warehousepincode,
				contactno: this.addwarehouse.contactno,
				contactpersonname: this.addwarehouse.contactpersonname,
				warehouseemail: this.addwarehouse.warehouseemail,
				totalsqft: this.addwarehouse.totalsqft,
				gstno: this.addwarehouse.gstno,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'UpdateWarehouse',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then((response) => {
					if (response.data.errorcode == 0) {
						this.$alertify.success("Warehouse Record Updated Successfully")
						this.addwarehousemodal = false
						this.getWarehouselist();
					} else {
						(response.data.errorcode == -1)
						this.$alertify.error(response.data.msg)
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10
		// 	this.getWarehouselist()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getWarehouselist()
		},
		//to get target id in edit action
		async getWarehouseRowData(data) {
			this.warehouseaction = 'edit';
			this.addwarehousemodal = true;
			this.$validator.reset();
			this.errors.clear();
			this.id = data.id;
			this.addwarehouse.warehouseid = data.warehouseid;
			this.addwarehouse.warehousename = data.warehousename;
			this.addwarehouse.warehouseaddress = data.warehouseaddress;
			this.addwarehouse.contactno = data.contactno;
			this.addwarehouse.contactpersonname = data.contactpersonname;
			this.addwarehouse.warehouseemail = data.warehouseemail;
			this.addwarehouse.warehousestate = data.warehousestate;
			this.addwarehouse.warehousecountry = data.warehousecountry;
			this.addwarehouse.warehousepincode = data.warehousepincode;
			this.addwarehouse.totalsqft = data.totalsqft;
			this.addwarehouse.gstno = data.gstno;
			let result = await Promise.all([
				this.getCityList()
			]);
			this.addwarehouse.warehousecity = data.warehousecity;

			this.getWarehouselist();
		},
		//checkwarehouse Status
		changeWarehouseStatus() {
			this.input = ({
				warehouseid: this.swarehouseid,
				warehousestatus: this.swarehousestatus,
			})
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'updateWarehouseStatus',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then((response) => {
					if (response.data.errorcode == 0) {
						this.closeWarehouseStatus();
						this.$alertify.success("Warehouse Status Updated Successfully");
					} else {
						alert("isssue")
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		//getWarehouseStatus
		getWarehouseStatus(data) {
			this.modalShow = true;
			if (data.warehousestatus == 1) {
				this.swarehouseid = data.warehouseid;
				this.swarehousestatus = 0;
			} else {
				this.swarehouseid = data.warehouseid;
				this.swarehousestatus = 1;
			}
		},
		//closeWarehouseStatus
		closeWarehouseStatus() {
			this.modalShow = false;
			this.swarehouseid = '';
			this.swarehousestatus = '';
			this.getWarehouselist();
		},

		//to reset search form
		resetForm() {
			this.totalRows = 0;
			this.warehousename = '';
			this.contactno = '';
			this.warehouseemail = '';
			this.getWarehouselist();
		},
		//validate all form fields on onsubmit()
		onSubmit: function (event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					console.log('form is invalid', this.model)
					return false;
				} else {
					console.log('form is valid', this.model)
					this.validateformat()
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/warehousemaster/warehousemaster.component.js